import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { CNConsultation } from 'src/app/models/cnconsultation';

@ManageType('ContactContentCardioComponent')
@Component({
  selector: 'app-contact-content-cardio',
  templateUrl: './contact-content-cardio.component.html',
  styleUrls: ['./contact-content-cardio.component.scss']
})
export class ContactContentCardioComponent implements OnInit, ContactContainer {

  private contentContact: CNConsultation;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * ContactContainer interface
   */

  @Input() set contact(theContact: CNConsultation) {
    this.contentContact = theContact;
    console.log('contact', this.contentContact);
  }

  get contact(): CNConsultation {
    return this.contentContact;
  }
}
